/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect} from 'react'
import VansDocument from './VansDocument'
import folderPic from '../images/folder.png'
import DocumentVans from './DocumentVans'
import DriverHistoryComponent from '../components/DriverHistoryComponent'
import PreviousDocumentsVans from './previousDovuments/PreviousDocumentsVans'

var selectedVan = null
var outsideDriverHistoryToggle = false
var outsidePrviousDocumentToggle = false

const VansComponent = (props) => {
    var CryptoJS = require("crypto-js");

    async function putData(url = '', data = {}) {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'PUT', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
            body: JSON.stringify(data)
            });

        return response ? response.json() : console.log('no reponse')
    };
    async function postData(url = '', data = {}) {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'POST', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
            body: JSON.stringify(data)
            });

        return response ? response.json() : console.log('no reponse')
    };
    async function getData(url = '') {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'GET', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
            });

        return response ? response.json() : console.log('no reponse')
    };
    async function deleteData(url = '') {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'DELETE', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
            });
    };
    const [ vanList, setVanList ] = useState([])
    const [ content, setContent ] = useState(null)
    const [ topContent, setTopContent ] = useState(null)
    const [ selectedVanState, setSelectedVanState] = useState(null)
    const [ middleContent, setMiddleContent ] = useState([])
    const [ renderGate, setRenderGate ] = useState(0)
    const [ driverHistoryToggle, setDriverHistoryToggle ] = useState(false)

    // state for driver history
    const [ driverHistoryButton, setDriverHistoryButton ] = useState(null)
    
    // state for driver history
    const [ previousDocumentsToggle, setPreviousDocumentsToggle ] = useState(false)


    // handle mapping owned vans
    useEffect( () => {
        // setContent(null)
        let localArray = []
        if (props.data) {
            props.data.sort( (a, b) => (a.registration.toLowerCase() > b.registration.toLowerCase() ? 1 :-1 ))
            if (props.selection !== 'Off-Hire Vans') {
                props.data.forEach( (van, vanID) => {
                    if (van.companyOwned === props.owned && van.offboarded !== true) {
                        localArray.push(
                            <div className='spacer_div_vans_list'>
                                <div className='h3_for_compliance_Page' onClick={(e, theVan) => handleVanSelection(e, van)}>
                                    {van.registration}-{van.make} {van.model} {van.year}
                                    <img src={folderPic} alt="Folder" className='image_in_documents_folder'/>
                                </div>
                            </div>
                        )
                    }
                })
            } else {
                props.data.forEach( (van, vanID) => {
                    if (van.offboarded === true) {
                        localArray.push(
                            <div className='spacer_div_vans_list'>
                                <div className='h3_for_compliance_Page' onClick={(e, theVan) => handleVanSelection(e, van)}>
                                    {van.registration}-{van.make} {van.model} {van.year}
                                    <img src={folderPic} alt="Folder" className='image_in_documents_folder'/>
                                </div>
                            </div>
                        )
                    }
                })
            }
        }
        setVanList(localArray)
        if (props.selectedVan) {
            setContent (
                <DocumentVans 
                    selectedVan={props.selectedVan}
                    vanDocs={props.selectedVan.imgArray}
                    reRender={props.reRender}
                    content={props.content}
                />
            )
        }
    }, [props.data, props.owned, props.selectedVan, props.selection])

    // map the toggle to outside
    useEffect( ( ) => {
        outsideDriverHistoryToggle = driverHistoryToggle
    }, [driverHistoryToggle])

    useEffect( () => {
        if (selectedVanState) {
            selectedVan = selectedVanState
        }
    }, [selectedVanState])

    // toggle the driver history page
    const handleToggleDriverHistory = () => {
        if (outsideDriverHistoryToggle === false) {
            setDriverHistoryToggle(true)
        } else {
            setContent(
                <DocumentVans 
                    selectedVan={selectedVanState}
                    vanDocs={selectedVanState.imgArray}
                    reRender={props.reRender}
                    content={props.content}
                />
            )
            setDriverHistoryToggle(false)
        }
    }

    useEffect( () => {
        outsidePrviousDocumentToggle = previousDocumentsToggle
    }, [previousDocumentsToggle])

    const handleTogglePreviousDocuments = () => {
        if (outsidePrviousDocumentToggle === false) {
            setPreviousDocumentsToggle(true)
        } else {
            setContent(
                <DocumentVans 
                    selectedVan={selectedVanState}
                    vanDocs={selectedVanState.imgArray}
                    reRender={props.reRender}
                    content={props.content}
                />
            )
            setPreviousDocumentsToggle(false)
        }
    }

    const handleOffHire = () => {
        if (selectedVanState) {
            putData(`https://backendpajamas.herokuapp.com/vehicles/${selectedVanState.vehicle_id}/`, {
                offboarded: true
            }).then( response => {
                props.reRender()
            })
        }
    }

    const handleOnBoard = () => {
        if (selectedVanState) {
            putData(`https://backendpajamas.herokuapp.com/vehicles/${selectedVanState.vehicle_id}/`, {
                offboarded: false
            }).then( response => {
                props.reRender()
            })
        }
    }

    useEffect( () => {
        if (previousDocumentsToggle) {
            setContent(
                <PreviousDocumentsVans 
                    selectedVan={selectedVanState}
                    vanDocs={selectedVanState.imgArray}
                    returnFunction={handleTogglePreviousDocuments}
                />
            )
        }
    }, [previousDocumentsToggle])

    useEffect( ( ) => {
        if (driverHistoryToggle) {
            setContent(
                <DriverHistoryComponent 
                    selectedVan={selectedVanState}
                />
            )
        }
    }, [driverHistoryToggle])

    useEffect( () => {
        let buttonContent;
        if (props.selection === 'Off-Hire Vans') {
            buttonContent = (
                <div className='offHireButton' onClick={handleOnBoard}>
                    onboard
                </div>
            )
        } else {
            buttonContent = (
                <div className='offHireButton' onClick={handleOffHire}>
                    Off-Hire
                </div>
            )
        }
        let arrayOfNames = [
            'Registration',
            'Vehicle Type',
            'Tax Due Date',
            'Mot Expire Date',
            'Motor Insurance Expiry',
            'G.I.T Insurance Expiry',
            'P.L. Insurance Expiry',
            'V5'
        ]
        let localArray = []
        let localMiddleArray = []
        if (selectedVanState) {
            if (arrayOfNames) {
                arrayOfNames.forEach( (ele, eleId) => {
                    localArray.push(
                        <div className='labelsForVanDocsTop'>
                            {ele}
                        </div>
                    )
                })
                arrayOfNames.forEach( (ele, eleId) => {
                    localMiddleArray.push(
                        <div className='labelsForVanDocs'>
                            
                        </div>
                    )
                })
            }
            localMiddleArray[0] = (
                <div className='labelsForVanDocs'>
                    {selectedVanState.registration}
                </div>
            )
            localMiddleArray[1] = (
                <div className='labelsForVanDocs'>
                    {selectedVanState.vtype}
                </div>
            )
            selectedVanState.imgArray.forEach( imageInnit => {
                if (imageInnit.name === 'TAX') {
                    localMiddleArray[2] = (
                        <div className='labelsForVanDocs'>
                            {new Date(imageInnit.expiryDate).toDateString() === 'Mon Sep 09 2052' ? 'n/a' : new Date(imageInnit.expiryDate).toLocaleDateString('en-GB')}
                        </div>
                    )
                }
                if (imageInnit.name === 'MOT') {
                    localMiddleArray[3] = (
                        <div className='labelsForVanDocs'>
                            {new Date(imageInnit.expiryDate).toDateString()  === 'Mon Sep 09 2052' ? 'n/a' : new Date(imageInnit.expiryDate).toLocaleDateString('en-GB')}
                        </div>
                    )
                }
                if (imageInnit.name === 'Motor Insurance') {
                    localMiddleArray[4] = (
                        <div className='labelsForVanDocs'>
                            {new Date(imageInnit.expiryDate).toDateString()  === 'Mon Sep 09 2052' ? 'n/a' : new Date(imageInnit.expiryDate).toLocaleDateString('en-GB')}
                        </div>
                    )
                }
                if (imageInnit.name === 'G.I.T. Insurance') {
                    localMiddleArray[5] = (
                        <div className='labelsForVanDocs'>
                            {new Date(imageInnit.expiryDate).toDateString()  === 'Mon Sep 09 2052' ? 'n/a' : new Date(imageInnit.expiryDate).toLocaleDateString('en-GB')}
                        </div>
                    )
                }
                if (imageInnit.name === 'P.L. Insurance') {
                    localMiddleArray[6] = (
                        <div className='labelsForVanDocs'>
                            {new Date(imageInnit.expiryDate).toDateString()  === 'Mon Sep 09 2052' ? 'n/a' : new Date(imageInnit.expiryDate).toLocaleDateString('en-GB')}
                        </div>
                    )
                }
                if (imageInnit.name === 'V5') {
                    localMiddleArray[7] = (
                        <div className='labelsForVanDocs'>
                            1
                        </div>
                    )
                }
            })
            setDriverHistoryButton(
                <div className='driverHistoryButtons'>
                    <div className='driverHistoryButton' onClick={handleToggleDriverHistory}>
                        Van Rental History
                    </div>
                    <div className='driverPreviousDocs' onClick={handleTogglePreviousDocuments}>
                        Previous Documents
                    </div>
                    {buttonContent}
                </div>
            )
        }
        setTopContent(localArray)
        setMiddleContent(localMiddleArray)
    }, [selectedVanState, props.vanDocs, props.selectedVan, props.selection])

    useEffect( () => {
        if (props.selectedVan) {
            handleVanSelection(props.selectedVan)
        }
    }, [props.selectedVan])

    // function for rendering van selection
    const handleVanSelection = (e, theVan) => { 
        if (theVan) {
            props.setSelection(theVan)
            setSelectedVanState(theVan)
            setContent (
                <DocumentVans 
                    selectedVan={theVan}
                    vanDocs={theVan.imgArray}
                    reRender={props.reRender}
                    content={props.content}
                />
            )
        }
    }
            
    // button for making new van
    const handleAddVan = (e, theVan) => {
        setContent(
            <VansDocument 
                owned={props.owned}
                reRender={props.reRender}
                content={props.content}
            />
        )
    }

    // useEffect( () => {
    //     console.log('van change: ', props.selectedVan)
    // }, [props.selectedVan])

    return (
        <div className={props.viewMe}>     
            <div className='inner_vans_component_div_left'>
                <button className='compliance_add_driver_button_submit' id='add_van_button' onClick={handleAddVan}>
                    <span className='span_in_complaince_button'>Add Van</span> 
                </button>
                <div className='van_list_van_component'>
                    {vanList}
                </div>
            </div>  
            <div className='inner_vans_component_div_right'>
                <div className='topContentCompanyVans'>
                        {driverHistoryButton}
                    <div className='topContentMain'>
                        {topContent}
                    </div>
                    <div className='topContentMain'>
                        {middleContent}
                    </div>
                </div>
                {content}
            </div>    
        </div>
    )
}

export default VansComponent